module.exports = __webpack_public_path__ + "img/1F497.361bac70.svg";